import { render, staticRenderFns } from "./initial.vue?vue&type=template&id=44cb2bd5&"
import script from "./initial.vue?vue&type=script&lang=js&"
export * from "./initial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports